import React, { useContext } from "react";
import { AxiosContext } from "./AxiosContext";
const ApiService = () => {
  const { authAxios, userAxios, authFormDataAxios, userFormDataAxios } =
    useContext(AxiosContext);

  const send_otp = async (data) => {
    try {
      const res = await authAxios.post("/auth/send_otp", data);
      return res.data;
    } catch (err) {
      console.log("error in axios send_otp ", err);
    }
  };

  const confirm_otp = async (data) => {
    try {
      const res = await userAxios.post(`/auth/confirm_otp`, data);
      return res.data;
    } catch (err) {
      console.log("error in axios confirm_otp ", err);
    }
  };

  const check_user_role_auth = async (data) => {
    try {
      const res = await authAxios.post("/auth/check_user_role_auth", data);
      return res.data;
    } catch (err) {
      console.log("error in axios check_user_role_auth ", err);
    }
  };

  const manual_login = async (data) => {
    try {
      const res = await authAxios.post("/auth/manual_login", data);
      return res.data;
    } catch (err) {
      console.log("error in axios manual_login ", err);
    }
  };

  const social_login = async (data) => {
    try {
      const res = await authAxios.post("/auth/social_login", data);
      return res.data;
    } catch (err) {
      console.log("error in axios social_login ", err);
    }
  };

  const register_user = async (formData) => {
    try {
      const res = await authFormDataAxios.post("/auth/register_user", formData);
      return res.data;
    } catch (err) {
      console.log("error in axios register_user ", err);
    }
  };

  const get_speciality_types = async () => {
    try {
      const res = await authAxios.get("/admin_list/get_speciality_types");
      return res.data;
    } catch (err) {
      console.log("error in axios get_speciality_types ", err);
    }
  };

  const get_states = async () => {
    try {
      const res = await authAxios.get("/admin_list/get_states");
      return res.data;
    } catch (err) {
      console.log("error in axios get_states ", err);
    }
  };

  const get_speciality = async (id) => {
    try {
      const res = await authAxios.get(`/admin_list/get_speciality/${id}`);
      return res.data;
    } catch (err) {
      console.log("error in axios get_speciality ", err);
    }
  };

  const get_licence_list = async () => {
    try {
      const res = await authAxios.get(
        `/admin_list/get_qualification_certificates`
      );
      return res.data;
    } catch (err) {
      console.log("error in axios get_licence_list ", err);
    }
  };

  const get_language_list = async () => {
    try {
      const res = await authAxios.get(`/admin_list/get_languages`);
      return res.data;
    } catch (err) {
      console.log("error in axios get_language_list ", err);
    }
  };

  const verify_license = async (data) => {
    try {
      const res = await authAxios.post(`/auth/verify_license`, data);
      return res.data;
    } catch (err) {
      console.log("error in axios verify_license ", err);
    }
  };

  const submit_profile = async (data) => {
    try {
      const res = await authAxios.post(`/auth/submit_profile`, data);
      return res.data;
    } catch (err) {
      console.log("error in axios submit_profile ", err);
    }
  };

  const get_user_details = async () => {
    try {
      const res = await userAxios.get(`/therapist/fetch_therapist_profile`);
      return res.data;
    } catch (err) {
      console.log("error in axios get_user_details ", err);
    }
  };

  const get_patient_user_details = async () => {
    try {
      const res = await userAxios.get(`/patient/get_profile`);
      return res.data;
    } catch (err) {
      console.log("error in axios get_patient_user_details ", err);
    }
  };

  const get_therapist_upcoming_appointment_list = async (page) => {
    try {
      const res = await userAxios.get(
        `/business/get_upcoming_appointment_list/${page}`
      );
      return res.data;
    } catch (err) {
      console.log(
        "error in axios get_therapist_upcoming_appointment_list ",
        err
      );
    }
  };

  const get_patient_upcoming_appointment_list = async (page) => {
    try {
      const res = await userAxios.get(
        `/patient/get_upcoming_appointment_list/${page}`
      );
      return res.data;
    } catch (err) {
      console.log("error in axios get_patient_upcoming_appointment_list ", err);
    }
  };
  const get_patient_past_appointment_list = async (page) => {
    try {
      const res = await userAxios.get(`/patient/get_past_appointments/${page}`);
      return res.data;
    } catch (err) {
      console.log("error in axios get_patient_past_appointment_list ", err);
    }
  };
  const get_therapist_past_appointment_list = async (page) => {
    try {
      const res = await userAxios.get(
        `/business/get_previous_appointments/${page}`
      );
      return res.data;
    } catch (err) {
      console.log("error in axios get_therapist_past_appointment_list ", err);
    }
  };

  const get_therapist_request_appointment_list = async (page) => {
    try {
      const res = await userAxios.get(`/business/get_requests_list/${page}`);
      return res.data;
    } catch (err) {
      console.log(
        "error in axios get_therapist_request_appointment_list ",
        err
      );
    }
  };

  const check_therapist_stripe_ac_status = async () => {
    try {
      const res = await userAxios.get(
        `/business/check_therapist_stripe_ac_status`
      );
      return res.data;
    } catch (err) {
      console.log("error in axios check_therapist_stripe_ac_status ", err);
    }
  };

  const therapist_approve_request = async (data) => {
    try {
      const res = await userAxios.post(`/business/approve_booking`, data);
      return res.data;
    } catch (err) {
      console.log("error in axios therapist_approve_request ", err);
    }
  };

  const therapist_reject_request = async (data) => {
    try {
      const res = await userAxios.post(`/business/reject_booking`, data);
      return res.data;
    } catch (err) {
      console.log("error in axios therapist_reject_request ", err);
    }
  };

  const therapist_cancel_request = async (data) => {
    try {
      const res = await userAxios.post(`/business/cancel_booking`, data);
      return res.data;
    } catch (err) {
      console.log("error in axios therapist_cancel_request ", err);
    }
  };

  const patient_cancel_booking_request = async (data) => {
    try {
      const res = await userAxios.post(`/booking/cancel_booking`, data);
      return res.data;
    } catch (err) {
      console.log("error in axios patient_cancel_booking_request ", err);
    }
  };

  const update_therapist_profile = async (formData) => {
    try {
      const res = await userFormDataAxios.post(
        `/therapist/update_profile`,
        formData
      );
      return res.data;
    } catch (err) {
      console.log("error in axios update_therapist_profile ", err);
    }
  };

  const update_patient_profile = async (formData) => {
    try {
      const res = await userFormDataAxios.post(
        `/patient/update_profile`,
        formData
      );
      return res.data;
    } catch (err) {
      console.log("error in axios update_patient_profile ", err);
    }
  };

  const log_out = async () => {
    try {
      const res = await userAxios.post(`/auth/logout`);
      return res.data;
    } catch (err) {
      console.log("error in axios log_out ", err);
    }
  };

  const select_notification_method = async (data) => {
    try {
      const res = await userAxios.post(
        `/comm/select_notification_methods`,
        data
      );
      return res.data;
    } catch (err) {
      console.log("error in axios select_notification_method ", err);
    }
  };

  const create_stripe_account = async () => {
    try {
      const res = await userAxios.post(`/business/create_stripe_account`, {
        device: "desktop",
      });
      return res.data;
    } catch (err) {
      console.log("error in axios create_stripe_account ", err);
    }
  };

  const get_therapist_booked_dates = async (slot) => {
    try {
      const res = await userAxios.get(`/business/get_booked_dates/${slot}`);
      return res.data;
    } catch (err) {
      console.log("error in axios get_therapist_booked_dates ", err);
    }
  };

  const get_therapist_booked_dates_for_patient = async (therapist_id, slot) => {
    try {
      const res = await userAxios.get(
        `/booking/get_booked_dates/${therapist_id}/${slot}`
      );
      return res.data;
    } catch (err) {
      console.log(
        "error in axios get_therapist_booked_dates_for_patient ",
        err
      );
    }
  };

  const therapist_reschedule_booking = async (data) => {
    try {
      const res = await userAxios.post(`/business/reschedule_booking`, data);
      return res.data;
    } catch (err) {
      console.log("error in axios therapist_reschedule_booking ", err);
    }
  };

  const patient_reschedule_booking = async (data) => {
    try {
      const res = await userAxios.post(`/booking/reschedule_booking`, data);
      return res.data;
    } catch (err) {
      console.log("error in axios patient_reschedule_booking ", err);
    }
  };

  const get_booking_timing = async (date, slot) => {
    try {
      const res = await userAxios.get(
        `/business/get_booking_timing/${date}/${slot}`
      );
      return res.data;
    } catch (err) {
      console.log("error in axios get_booking_timing ", err);
    }
  };

  const get_booking_timing_for_patient = async (therapist_id, date, slot) => {
    try {
      const res = await userAxios.get(
        `/booking/get_booking_timing/${therapist_id}/${date}/${slot}`
      );
      return res.data;
    } catch (err) {
      console.log("error in axios get_booking_timing_for_patient ", err);
    }
  };

  const get_therapist_specific_booking_details = async (bookingId) => {
    try {
      const res = await userAxios.get(
        `/business/get_specific_booking_details/${bookingId}`
      );
      return res.data;
    } catch (err) {
      console.log(
        "error in axios get_therapist_specific_booking_details ",
        err
      );
    }
  };

  const get_patient_specific_booking_details = async (bookingId) => {
    try {
      const res = await userAxios.get(
        `/booking/get_specific_booking_details/${bookingId}`
      );
      return res.data;
    } catch (err) {
      console.log("error in axios get_patient_specific_booking_details ", err);
    }
  };

  const get_therapist_booking_details = async (bookingId, patientId) => {
    try {
      const res = await userAxios.get(
        `/business/get_booking_details/${bookingId}/${patientId}`
      );
      return res.data;
    } catch (err) {
      console.log("error in axios get_therapist_booking_details ", err);
    }
  };

  const get_chat_history = async (clientId, page) => {
    try {
      const res = await userAxios.get(
        `/comm/get_chat_history/${clientId}/${page}`
      );
      return res.data;
    } catch (err) {
      console.log("error in axios get_chat_history ", err);
    }
  };

  const fetch_communicated_client_list = async (page) => {
    try {
      const res = await userAxios.get(
        `/comm/fetch_communicated_client_list/${page}`
      );
      return res.data;
    } catch (err) {
      console.log("error in axios fetch_communicated_client_list ", err);
    }
  };

  const fetch_total_chat_users = async () => {
    try {
      const res = await userAxios.get(`/comm/fetch_total_chat_users`);
      return res.data;
    } catch (err) {
      console.log("error in axios fetch_total_chat_users ", err);
    }
  };

  const get_upcoming_appointment_of_specific_user = async (user_id) => {
    try {
      const res = await userAxios.get(
        `/business/get_upcoming_appointment_of_specific_user/${user_id}`
      );
      return res.data;
    } catch (err) {
      console.log(
        "error in axios get_upcoming_appointment_of_specific_user ",
        err
      );
    }
  };

  const get_upcoming_appointment_of_specific_user_for_patient = async (
    user_id
  ) => {
    try {
      const res = await userAxios.get(
        `/patient/get_upcoming_appointment_of_specific_user/${user_id}`
      );
      return res.data;
    } catch (err) {
      console.log(
        "error in axios get_upcoming_appointment_of_specific_user_for_patient ",
        err
      );
    }
  };

  const filter_therapist = async (page, query) => {
    try {
      const res = await userAxios.get(
        `/patient/filter_therapist/${page}${query}`
      );
      return res.data;
    } catch (err) {
      console.log("error in axios filter_therapist ", err);
    }
  };

  const get_agora_token = async (channel) => {
    try {
      const res = await userAxios.get(
        `/comm/agora_token/rtc/${channel}/uid/0/expiry/3600`
      );
      return res.data.data;
    } catch (err) {
      console.log("error in axios get_agora_token ", err);
    }
  };

  const get_earning_details = async (page) => {
    try {
      const res = await userAxios.get(`/business/get_earning_details/${page}`);
      return res.data;
    } catch (err) {
      console.log("error in axios get_earning_details ", err);
    }
  };

  const public_contact_us = async (data) => {
    try {
      const res = await authAxios.post(`/comm/public_contact_us`, data);
      return res.data;
    } catch (err) {
      console.log("error in axios public_contact_us ", err);
    }
  };

  const user_contact_us = async (data) => {
    try {
      const res = await userAxios.post(`/comm/contact_us`, data);
      return res.data;
    } catch (err) {
      console.log("error in axios user_contact_us ", err);
    }
  };

  const delete_chat = async (data) => {
    try {
      const res = await userAxios.post(`/comm/delete_chat`, data);
      return res.data;
    } catch (err) {
      console.log("error in axios delete_chat ", err);
    }
  };

  const change_online_status = async (data) => {
    try {
      const res = await userAxios.post(`/business/change_online_status`, data);
      return res.data;
    } catch (err) {
      console.log("error in axios change_online_status ", err);
    }
  };
  const create_card = async (data) => {
    try {
      const res = await userAxios.post(`/patient/add_card`, data);
      return res.data;
    } catch (err) {
      console.log("error in axios create_card ", err);
    }
  };

  const get_setup_client_secret = async () => {
    try {
      const res = await userAxios.post(`/patient/get_client_secret`);
      return res.data;
    } catch (err) {
      console.log("error in axios get_setup_client_secret ", err);
    }
  };

  const get_card_list = async () => {
    try {
      const res = await userAxios.get(`/patient/get_card_list`);
      return res.data;
    } catch (err) {
      console.log("error in axios get_card_list ", err);
    }
  };

  const set_default_card = async (data) => {
    try {
      const res = await userAxios.post(`/patient/set_default_card`, data);
      return res.data;
    } catch (err) {
      console.log("error in axios set_default_card ", err);
    }
  };

  const delete_card = async (data) => {
    try {
      const res = await userAxios.post(`/patient/delete_card`, data);
      return res.data;
    } catch (err) {
      console.log("error in axios delete_card ", err);
    }
  };

  const get_therapist_full_details_for_patient = async (id) => {
    try {
      const res = await userAxios.get(
        `/patient/fetch_therapist_full_details/${id}`
      );
      return res.data;
    } catch (err) {
      console.log(
        "error in axios get_therapist_full_details_for_patient ",
        err
      );
    }
  };

  const add_booking = async (data) => {
    try {
      const res = await userAxios.post(`/booking/add_booking`, data);
      return res.data;
    } catch (err) {
      console.log("error in axios add_booking ", err);
    }
  };

  const add_rating = async (data) => {
    try {
      const res = await userAxios.post(`/booking/add_rating`, data);
      return res.data;
    } catch (err) {
      console.log("error in axios add_rating ", err);
    }
  };

  const add_to_favorite = async (data) => {
    try {
      const res = await userAxios.post(`/patient/add_to_favorite`, data);
      return res.data;
    } catch (err) {
      console.log("error in axios add_to_favorite ", err);
    }
  };

  const cancel_booking_List_for_patient = async (page) => {
    try {
      const res = await userAxios.get(
        `/patient/get_canceled_appointments/${page}`
      );
      return res.data;
    } catch (err) {
      console.log("error in axios cancel_booking_List_for_patient ", err);
    }
  };

  const get_therapist_reviews_list = async (id, page) => {
    try {
      const res = await userAxios.get(
        `/patient/get_therapist_reviews/${id}/${page}`
      );
      return res.data;
    } catch (err) {
      console.log("error in axios get_therapist_reviews_list ", err);
    }
  };

  const get_favorites_list = async (page) => {
    try {
      const res = await userAxios.get(`/patient/get_favorites_list/${page}`);
      return res.data;
    } catch (err) {
      console.log("error in axios get_favorites_list ", err);
    }
  };

  const filter_therapist_public = async (page, query) => {
    try {
      const res = await userAxios.get(
        `/patient/filter_therapist_public/${page}${query}`
      );
      return res.data;
    } catch (err) {
      console.log("error in axios filter_therapist_public ", err);
    }
  };

  const get_popular_therapist_public = async () => {
    try {
      const res = await userAxios.get(
        `/patient/get_popular_therapist_public/[]/1`
      );
      return res.data;
    } catch (err) {
      console.log("axios error in get_popular_therapist_public = ", err);
    }
  };

  const get_popular_therapist = async () => {
    try {
      const res = await userAxios.get(`/patient/get_popular_therapist/[]/1`);
      return res.data;
    } catch (err) {
      console.log("axios error in get_popular_therapist = ", err);
    }
  };

  const update_timezone_us = async (data) => {
    try {
      const res = await userAxios.post(`/comm/update_timezone_`, data);
      return res.data;
    } catch (err) {
      console.log("error in update_timezone_us ", err);
    }
  };

  const get_specific_pages_details = async (title) => {
    try {
      const res = await userAxios.get(
        `/admin_list/get_specific_page_details_user/${title}`
      );
      return res.data;
    } catch (err) {
      console.log("error in axios get_specific_pages_details ", err);
    }
  };

  const get_web_content_details = async () => {
    try {
      const res = await userAxios.get(`/admin_list/get_app_content`);
      return res.data;
    } catch (err) {
      console.log("error in axios get_web_content_details ", err);
    }
  };

  const get_coupons_list = async () => {
    try {
      const res = await userAxios.get(`/patient/get_coupons_list`);
      return res.data;
    } catch (err) {
      console.log("error in axios get_coupons_list ", err);
    }
  };

  const deactivate_account = async () => {
    try {
      const res = await userAxios.post(`/comm/deactivate_account`);
      return res.data;
    } catch (err) {
      console.log("error in axios deactivate_account ", err);
    }
  };

  const check_duplicate_number_for_update_number = async (data) => {
    try {
      const res = await userAxios.post(
        "/comm/check_duplicate_number_for_update_number",
        data
      );
      return res.data;
    } catch (err) {
      console.log(
        "error in axios check_duplicate_number_for_update_number ",
        err
      );
    }
  };

  const confirm_otp_for_update_number = async (data) => {
    try {
      const res = await userAxios.post(
        `/comm/confirm_otp_for_update_phone`,
        data
      );
      return res.data;
    } catch (err) {
      console.log("error in axios confirm_otp_for_update_number ", err);
    }
  };

  const update_contact_number = async (data) => {
    try {
      const res = await userAxios.post(`/comm/update_contact_number`, data);
      return res.data;
    } catch (err) {
      console.log("error in axios update_contact_number ", err);
    }
  };

  const get_news_list = async (data) => {
    try {
      const res = await userAxios.post(`/comm/news_list/${data.page}`, data);
      return res.data;
    } catch (err) {
      console.log("error in axios get_news_list ", err);
    }
  };

  const get_news_category_list = async (data) => {
    try {
      const res = await userAxios.post(`/comm/get_news_category_list`, data);
      return res.data;
    } catch (err) {
      console.log("error in axios get_news_category_list ", err);
    }
  };

  const get_specific_news_deatils = async (data) => {
    try {
      const res = await userAxios.post(`/comm/get_specific_news_deatils`, data);
      return res.data;
    } catch (err) {
      console.log("error in axios get_specific_news_deatils ", err);
    }
  };

  const get_dashboard_banner_details_and_list = async (data) => {
    try {
      const res = await userAxios.get(
        `/comm/get_dashboard_banner_details_and_list`,
        data
      );
      return res.data;
    } catch (err) {
      console.log("error in axios get_dashboard_banner_details_and_list ", err);
    }
  };

  // ******************************************* DEBUG LOGS APIs  ******************************************

  const post_debug_logs = async (data) => {
    try {
      const res = await authAxios.post("/developer/debug_logs", data);
      return res.data;
    } catch (err) {
      console.log("error in axios post_debug_logs ", err);
    }
  };

  const get_debug_logs = async (lines = 1000) => {
    try {
      const res = await authAxios.get(`/developer/debug_logs?lines=${lines}`);
      return res.data;
    } catch (err) {
      console.log("error in axios get_debug_logs ", err);
    }
  };

  const delete_debug_logs = async () => {
    try {
      const res = await authAxios.delete("/developer/debug_logs");
      return res.data;
    } catch (err) {
      console.log("error in axios delete_debug_logs ", err);
    }
  };

  return {
    send_otp,
    confirm_otp,
    manual_login,
    social_login,
    get_speciality_types,
    get_speciality,
    get_states,
    register_user,
    get_licence_list,
    get_language_list,
    submit_profile,
    get_user_details,
    get_therapist_upcoming_appointment_list,
    get_therapist_past_appointment_list,
    get_therapist_request_appointment_list,
    therapist_approve_request,
    therapist_reject_request,
    therapist_cancel_request,
    update_therapist_profile,
    log_out,
    select_notification_method,
    check_therapist_stripe_ac_status,
    create_stripe_account,
    get_therapist_booked_dates,
    therapist_reschedule_booking,
    get_booking_timing,
    get_therapist_specific_booking_details,
    get_therapist_booking_details,
    get_chat_history,
    fetch_communicated_client_list,
    fetch_total_chat_users,
    get_upcoming_appointment_of_specific_user,
    get_agora_token,
    get_earning_details,
    public_contact_us,
    user_contact_us,
    delete_chat,
    change_online_status,
    get_patient_user_details,
    update_patient_profile,
    create_card,
    get_setup_client_secret,
    get_card_list,
    set_default_card,
    delete_card,
    filter_therapist,
    get_therapist_full_details_for_patient,
    get_booking_timing_for_patient,
    get_therapist_booked_dates_for_patient,
    add_booking,
    get_therapist_reviews_list,
    get_patient_upcoming_appointment_list,
    patient_reschedule_booking,
    patient_cancel_booking_request,
    get_patient_past_appointment_list,
    get_patient_specific_booking_details,
    add_rating,
    cancel_booking_List_for_patient,
    get_upcoming_appointment_of_specific_user_for_patient,
    add_to_favorite,
    get_favorites_list,
    filter_therapist_public,
    get_popular_therapist_public,
    get_popular_therapist,
    check_user_role_auth,
    update_timezone_us,
    get_specific_pages_details,
    get_web_content_details,
    get_coupons_list,
    deactivate_account,
    check_duplicate_number_for_update_number,
    confirm_otp_for_update_number,
    update_contact_number,
    get_news_list,
    get_news_category_list,
    get_specific_news_deatils,
    get_dashboard_banner_details_and_list,
    verify_license,
    post_debug_logs,
    get_debug_logs,
    delete_debug_logs,
  };
};

export default ApiService;
